module.exports = __webpack_public_path__ + "static/media/sevenBigImg.27ff1d01.png";